import '@prismeet/react/styles.css'
import '@prismeet/react/fonts'
import '@/styles/global.scss'

import { configureApiClient } from '@host/auth'
import { initRemotes } from '@host/mf'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { API_BASE_URL, parseRemotesFromEnv } from './constants'

/**
 * Порядок запуска.
 *
 * 1. Настроить http-клиент — до него никто не должен ходить в сеть.
 * 2. Зарегистрировать ремоуты, чтобы первый же переход в раздел нашёл
 *    свой микрофронт, а не показал заглушку «не задеплоен».
 * 3. И только теперь рендерить.
 *
 * Моков здесь больше нет. Раньше на этом месте стоял запуск service worker'а
 * с MSW, и он подвёл ровно там, где мок обязан быть надёжнее всего:
 * отказ воркера выглядел как обычный 404 из сети. Dev-API переехал
 * в middleware самого dev-сервера (`@host/api-contracts/vite`), поэтому
 * приложению теперь нечего знать про моки — оно просто ходит по /api,
 * как ходило бы к настоящему бэкенду.
 */
async function bootstrap(): Promise<void> {
  configureApiClient({ baseUrl: API_BASE_URL })

  await initRemotes(parseRemotesFromEnv())

  const container = document.getElementById('root')
  if (!container) throw new Error('В разметке нет элемента #root')

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
